require('../../../modules/es.string.strike');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').strike;
